import React, { FC } from 'react';

import classNames from 'classnames';
import { useBadgeProps, BADGE_CLASS } from '@sede-x/shell-ds-react-base';

import * as Styled from './Badge.styles';
import { IBadgeProps } from './Badge.types';

const Badge: FC<IBadgeProps> = ({ className = '', ...props }) => {
  const { fontStyles, children, shouldRenderChildren, iconComponent, backgroundColor, color, ...badgeProps } =
    useBadgeProps(props);

  return (
    <Styled.Badge
      className={classNames(BADGE_CLASS, className)}
      $backgroundColor={backgroundColor}
      $color={color}
      {...props}
      {...badgeProps}
    >
      {iconComponent}
      {shouldRenderChildren && <Styled.BadgeText fontStyles={fontStyles}>{children}</Styled.BadgeText>}
    </Styled.Badge>
  );
};

export default Badge;
